export default __webpack_public_path__ + "static/media/Artes-Teatro.b6772039.png";